<template>
	<section :id="data.id" class="content-text-boxes">
		<ContentText
			v-for="(contentBox, index) in contentTextBoxes"
			:key="`${contentBox.sys.id}-${index}`"
			:id="contentBox?.sys?.id"
			:content="contentBox.fields"
		/>
	</section>
</template>

<script setup>
const props = defineProps({
	data: {
		type: Object
	}
});

const contentTextBoxes = computed(() => props?.data?.data?.boxes ?? {});
</script>